module.exports = {
  constructorMethods: require("./constructorMethods"),
  bootstrap: require("./bootstrap"),
  properties: require("./properties")
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-contract/lib/contract/index.js
// module id = 2727
// module chunks = 0 1